module.exports = __webpack_public_path__ + "img/083.b6e581cf.png";